import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { USER_SESSION_LOGOUT, USER_SESSIONS, USER_SESSIONS_LOGOUT_ALL } from '../constants/actionTypes'
import * as API from '../constants/api'

export const getUserSessions = createAsyncThunk(
  USER_SESSIONS,
  async (params: PayloadCreatorParams<`${typeof API.USER_SESSIONS}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.getUserSessions(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const logoutUserSession = createAsyncThunk(
  USER_SESSION_LOGOUT,
  async (
    params: PayloadCreatorParams<`${typeof API.USER_SESSION_LOGOUT}{id}`, 'post'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.logoutUserSession(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const logoutAllUserSessions = createAsyncThunk(
  USER_SESSIONS_LOGOUT_ALL,
  async (
    params: PayloadCreatorParams<`${typeof API.USER_SESSIONS_LOGOUT_ALL}`, 'post'> | undefined,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.logoutAllUserSessions(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const getUserSessionsClear = createAction(`${USER_SESSIONS}/clear`)
